import { type IncomeSplitConfigLegacy } from '@fruitful/income-split';

import { requestBuilder } from '../../../http/RequestBuilder';

const useSaveIncomeSplit = requestBuilder.mutation<
    IncomeSplitConfigLegacy,
    Partial<IncomeSplitConfigLegacy>
>({
    endpoint: '/api/paycheck-routing/create',
    method: 'POST',
});

export default useSaveIncomeSplit;
